export default __webpack_public_path__ + "static/media/benevity-glyph.acf38d1c.png";